
import { useEffect, useRef } from 'react';

function PositioningStatement() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-32 bg-white">
      <div
        ref={sectionRef}
        className="max-w-3xl mx-auto px-6 lg:px-12 text-center opacity-0 translate-y-10 transition-all duration-700 ease-out"
      >
        <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#2DD4BF] mb-6">
          Our Philosophy
        </p>

        <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-gray-900 mb-10 leading-[1.1] tracking-tight">
          Built for Leaders.
          <br />
          Designed for Scale.
        </h2>

        <div className="space-y-6 text-base md:text-lg text-gray-500 leading-relaxed font-light">
          <p>
            Wazier AI operates as your strategic AI advisor — designing and deploying infrastructure that supports real growth across Home Services, Healthcare, Real Estate, and Professional Services.
          </p>
          <p>
            Our approach is structured, measured, and engineered for long-term performance — not short-term experimentation.
          </p>
        </div>
      </div>
    </section>
  );
}

export default PositioningStatement;
